import { GetMenuAppRestaurantDataResponse } from "api-types";
import { AxiosInstance } from "axios";

import { UseQueryResult, useQuery } from "react-query";

import { getMenuAppRestaurantData } from "../menus-client";

export const useMenuAppRestaurantDataQuery = (
  client: AxiosInstance,
  urlSlug: string
): UseQueryResult<GetMenuAppRestaurantDataResponse> => {
  return useQuery(["menuAppRestaurantData", urlSlug], () =>
    // no need to query if we don't have the urlSlug, or before the url is parsed.
    !urlSlug
      ? Promise.resolve(undefined)
      : getMenuAppRestaurantData(client, urlSlug)
  );
};
